import { Button } from '@askable/ui/core/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogOverlay } from '@askable/ui/core/dialog';
import { useTranslation } from 'react-i18next';

import { DeviceDisabledInstruction } from './DeviceDisabledInstruction';

import type { FC } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const DevicePermissionDeniedDialog: FC<Props> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onOpenChange={isOpen => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogOverlay>
        <DialogContent data-testid="device-denied-dialog">
          <DialogHeader>{t('permissions.cameraMicrophoneBlocked')}</DialogHeader>
          <DeviceDisabledInstruction mediaType="camera-and-microphone" />
          <DialogFooter>
            <Button onClick={onClose}>{t('global.dismiss')}</Button>
          </DialogFooter>
        </DialogContent>
      </DialogOverlay>
    </Dialog>
  );
};
